angular.module( 'acme.view.application.programs.combos.create.configure', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.programs.combos.create.configure.controllers',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.directive.integer',
  'acme.common.directive.numeric',
  'acme.common.directive.priceListPicker'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var programsCombosCreateConfigure = {
        name: 'application.programs.combos.create.configure',
        url: '/configure',
        views: {
          "subview-main": {
            controller: 'ProgramsCombosCreateConfigureController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/combos/create/configure/configure.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Combo Details'
        },
        resolve: {
          EventTemplatesData: [ 'ApiService', 'HelpersService', function(ApiService, HelpersService) {
            return ApiService.program.names(false, HelpersService.getPaginator());
          }],
          AddonsData: [ 'ApiService', 'HelpersService', function(ApiService, HelpersService) {
            return ApiService.inventory.list(angular.extend({ addonTypes: 'doNotTrack' }, HelpersService.getPaginator()));
          }]
        }
      },
      programsCombosEditConfigure = {
        name: 'application.programs.combos.edit.configure',
        url: '/configure',
        views: {
          "subview-main": {
            controller: 'ProgramsCombosCreateConfigureController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/programs/combos/create/configure/configure.tpl.html'
          }
        },
        data: {
          pageTitle: 'Edit Combo Details'
        },
        resolve: {
          EventTemplatesData: [ 'ApiService', 'HelpersService', function(ApiService, HelpersService) {
            return ApiService.program.names(false, HelpersService.getPaginator());
          }],
          AddonsData: [ 'ApiService', 'HelpersService', function(ApiService, HelpersService) {
            return ApiService.inventory.list(angular.extend({ addonTypes: 'doNotTrack' }, HelpersService.getPaginator()));
          }]
        }
      };

    $stateProvider
      .state(programsCombosCreateConfigure)
      .state(programsCombosEditConfigure);
});
